export default "__VITE_ASSET__cI7Elp$Q__"